import { LockKeyhole, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function LandingTrust() {
    const { t } = useTranslation();
    return (
        <section className="landing-trust" aria-labelledby="trust-title">
            <div className="landing-container landing-trust-grid">
                <div className="landing-section-heading">
                    <p className="landing-eyebrow">{t('trust.badge')}</p>
                    <h2 id="trust-title">{t('trust.title')}</h2>
                    <p>{t('trust.subtitle')}</p>
                </div>
                <div className="landing-trust-items">
                    {[ShieldCheck, LockKeyhole].map((Icon, index) => <div key={index}>
                        <Icon size={22} strokeWidth={1.6} aria-hidden="true" /><div><h3>{t(`trust.items.${index}.title`)}</h3><p>{t(`trust.items.${index}.desc`)}</p></div>
                    </div>)}
                </div>
            </div>
        </section>
    );
}
